// This icon file is generated automatically.
var CloudUploadFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 20 20", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11 17v-3.92h2.46L10 9l-3.45 4.08H9V17H4a4 4 0 01-.8-7.92A2.99 2.99 0 016 5c.55 0 1.07.14 1.51.4A4.5 4.5 0 0116 7.77H16V9a4 4 0 110 8h-5z", "fill-rule": "evenodd" } }] }, "name": "cloud-upload", "theme": "filled" };
export default CloudUploadFilled;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/CloudUploadFilled.js
// module id = 2263
// module chunks = 0